<div class="container-fluid">


<div class="button-container">

    <div class="button-item d-flex justify-content-center align-items-center">
        <span class="create" (click)="open(content)">
            <i class="fi fi-rr-add"></i>
         </span>
    </div>

    <div class="button-item" *ngFor="let table of data">
        <div class="card  bg-none d-flex justify-content-center" *ngIf="!load">
            <div *ngIf="table.svgBase64">
                <img [src]="table.svgBase64" alt="QR Code" class="w-100">
            </div>
            <div class="mt-2 d-flex justify-content-center">
                <button class="btn bg-white delete text-danger border-0" (click)="delete(table?.id)">
                    <span *ngIf="loadDelete && table.id == deleteId" class="spinner-border spinner-border-sm" role="status" ></span>
                    <i *ngIf="!loadDelete ||  table.id !== deleteId" class="fi fi-rr-trash"></i>
                </button>
                <button class="btn bg-white delete text-dark mx-3 border-0" (click)="downloadQRCode(table?.svgBase64)">
                    <i class="fi fi-rr-download text-success"></i>
                </button>
            </div>
        </div>
    </div>


</div>
</div>
<ng-template #content let-modal>
    <div class="modal-body m-auto">
        <div class="custom-dropdown-menu">
            <div [formGroup]="form" (ngSubmit)="create()">
                <div class="form-floating">
                    <input
                        type="number"
                        class="form-control"
                        formControlName="table_num"
                        id="table"
                        placeholder="{{'TABLE_NUMBER' | translate}}">
                    <label for="table">{{'TABLE_NUMBER' | translate}}</label>
                </div>
                <button type="button" class="btn btn-primary mt-2 w-100" (click)="create()">
                    <span *ngIf="isTableLoad" class="spinner-border spinner-border-sm" role="status" ></span>
                    {{'ADD' | translate}}
                </button>
            </div>
        </div>
    </div>
</ng-template>
  
